import Vue from 'vue'
import template from './_travel.pug'
import {isRailway} from '../../../lib/travels/operation-type'

const TSC_CODE = '1'
const QR_ID_CODE = '2'
const TNE_CODE = '4'

const VALIDATION_TYPE = 8
const PARTIAL_VALIDATION_TYPE = 12

const VALIDATION_TYPE_FLAT_RATE = 1
const VALIDATION_TYPE_HOP_ON_HOP_OFF = 2
const VALIDATION_TYPE_PENALTY = 3

export default Vue.extend({
  template: template(),
  props: {
    travel: {
      type: Object,
      default: () => ({})
    },
    currentAlias: {
      type: Object,
      default: null
    }
  },
  computed: {
    isTsc() {
      return this.travel.media_type === TSC_CODE
    },

    isQr() {
      return this.travel.media_type === QR_ID_CODE
    },

    isTne() {
      return this.travel.media_type === TNE_CODE
    },

    isValidationTravel() {
      return this.travel.type === VALIDATION_TYPE
    },

    isPartialValidationTravel() {
      return this.travel.type === PARTIAL_VALIDATION_TYPE
    },

    isFlatRateTravel() {
      if (!this.isValidationTravel) return false

      return this.travel.validation_type === VALIDATION_TYPE_FLAT_RATE
    },

    isPenaltyTravel() {
      if (!this.isValidationTravel) return false

      return this.travel.validation_type === VALIDATION_TYPE_PENALTY
    },

    date() {
      if (this.$administrativeAreaTimeZone) {
        const date = moment(this.travel.operation_date).tz(this.$administrativeAreaTimeZone)

        return date.format('DD MMM HH:mm').replace('.', '')
      }

      return ''
    },

    hasDestination() {
      return this.travel.has_destination
    },

    stopsText() {
      if (this.hasDestination) { return this.stopFromStopToText }

      return this.stopText
    },

    stopFromStopToText() {
      const data = {
        stopFromName: this.travel.stop ? this.travel.stop.name : '',
        stopToName: this.travel.stop_to ? this.travel.stop_to.name : ''
      }
      if (Object.values(data).join().trim() === ',') return ''

      return this.$t('travels.stops.originDestination', data)
    },

    stopText() {
      const stopName = this.travel.stop ? this.travel.stop.name : ''

      return this.$t('travels.stops.onlyOrigin', {stopName})
    },

    travelBusImage() {
      if (!this.travel.voided_validation) {
        switch (this.travel.type) {
          case PARTIAL_VALIDATION_TYPE:
            return require('assets/images/ilustrations/private-area/money-bus.svg')
          case VALIDATION_TYPE:
            return this.validationTypeBusImage
          default: return ''
        }
      } else {
        // TODO Añadir aquí imagen de validación cancelada
        return require('assets/images/ilustrations/private-area/ticket.svg')
      }
    },

    validationTypeBusImage() {
      switch (this.travel.validation_type) {
        case VALIDATION_TYPE_HOP_ON_HOP_OFF:
          return require('assets/images/ilustrations/private-area/blue-bus.svg')
        case VALIDATION_TYPE_PENALTY:
          return require('assets/images/ilustrations/private-area/red-bus.svg')
        case VALIDATION_TYPE_FLAT_RATE:
          return require('assets/images/ilustrations/private-area/ticket.svg')
        default: return ''
      }
    },

    travelTypeIcon() {
      switch (this.travel.type) {
        case VALIDATION_TYPE: return this.validationTypeIcon
        case PARTIAL_VALIDATION_TYPE: return 'ns-icon-bus'
        default: return ''
      }
    },

    validationTypeIcon() {
      switch (this.travel.validation_type) {
        case VALIDATION_TYPE_HOP_ON_HOP_OFF: return 'double-icon'
        case VALIDATION_TYPE_PENALTY: return 'double-icon--red-arrow'
        case VALIDATION_TYPE_FLAT_RATE: return 'ns-icon-ticket text-gray2'
        default: return ''
      }
    },

    paymentMediaIcon() {
      switch (this.travel.media_type) {
        case QR_ID_CODE: return 'ns-icon-qr'
        case TNE_CODE: return 'ns-icon-tne'
        case TSC_CODE: return 'ns-icon-tne'
        default: return ''
      }
    },

    mediaTypeText() {
      const mediaType = this.$t(`travels.mediaTypes.${this.travel.media_type}`)
      if (this.isTne) return this.tneText(mediaType)
      else if (this.isTsc) return this.tscText(mediaType)

      return mediaType
    },
    travelTypeName() {
      switch (this.travel.type) {
        case VALIDATION_TYPE: return this.validationTypeName
        case PARTIAL_VALIDATION_TYPE: return 'onBoard'
        default: return ''
      }
    },

    validationTypeName() {
      switch (this.travel.validation_type) {
        case VALIDATION_TYPE_FLAT_RATE: return 'flatRate'
        case VALIDATION_TYPE_HOP_ON_HOP_OFF: return 'hopOnHopOff'
        case VALIDATION_TYPE_PENALTY: return 'penalty'
        default: return ''
      }
    },

    voidedValidationClass() {
      return this.travel.voided_validation ? 'voided-validation' : ''
    },

    isRailway() {
      return isRailway(this.travel.tipo_operacion)
    }
  },
  methods: {
    calculateColor(travel) {
      if (travel?.route?.color) {
        if (travel.voided_validation) {
          return '--bg-pill: grey'
        }

        return `--bg-pill: ${travel.route.color}`
      }

      return ''
    },

    tneText(mediaType) {
      if (this.travel.payment_media) {
        return this.travel.payment_media.alias || mediaType
      }

      return this.$t('travels.voidTne')
    },
    tscText(mediaType) {
      const text = `${this.currentAlias.label.slice(0, 10)}...-${this.currentAlias.label.slice(-3)}`
      const text2 = this.currentAlias.label
      const t = [text, text2]

      return t || mediaType
    }

  }
})
